import script from "./DotLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./DotLoader.vue?vue&type=script&setup=true&lang=js"

import "./DotLoader.vue?vue&type=style&index=0&id=095e3f00&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-095e3f00"]])

export default __exports__